import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  min-width: 600px;
  max-width: 800px;
`;

export const WrapperInput = styled.div`
  margin-bottom: 20px;
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
`;

export const FileInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  
  span {
    color: #666;
    font-size: 14px;
  }
`;

